var map = {
	"./screenshot_01.jpg": 6154,
	"./screenshot_02.jpg": 3381,
	"./screenshot_03.jpg": 5768,
	"./screenshot_04.jpg": 651,
	"./screenshot_05.jpg": 494,
	"./screenshot_06.jpg": 1993,
	"./screenshot_07.jpg": 7852,
	"./screenshot_08.jpg": 5663
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1033;